<template>
  <div class="main">
    <div class="search">
      <span class="search__title">RECHERCHER VOS ARTICLES</span>
      <div class="search__input__wrapper">
        <FontAwesomeIcon
          icon="search"
          class="search__input__icon"
          size="2x"
        />
        <input
          v-model.trim="filter"
          v-focus
          class="search__input"
          placeholder="recherche"
          @input="search"
        >
      </div>
      <PlanVenteTree
        @planVenteClicked="clickPlanVenteRegroupement"
      />
    </div>
    <div class="articles">
      <span class="articles__title">RESULTATS DE RECHERCHE</span>
      <div class="articles__list">
        <span
          v-if="showTip"
          class="articles__list__tip"
        >{{ tip }}</span>
        <span
          v-for="article of filteredArticles"
          :key="article.codeArticle"
          :class="isSelected(article.codeArticle, article.codeDeclinaison) ? 'article--selected' : ''"
          class="article"
          @click="selectFilteredArticle(article)"
        >{{ article.codeArticle }} {{ article.designation1 }}</span>
      </div>
      <FontAwesomeIcon
        icon="spinner"
        size="2x"
        :class="searchingFilteredArticles ? 'loader--active' : 'loader--hidden'"
        class="loader"
        spin
      />
      <Pagination
        v-if="hasFilteredArticles"
        :current="filteredArticlesPage"
        :pages="filteredArticlesPages"
        @change="setPageFilteredArticles"
      />
    </div>
    <div class="selected-articles">
      <span class="selected-articles__title">VOTRE SELECTION</span>
      <ul class="selected-articles__list">
        <li
          v-for="article of selectedFilteredArticles"
          :key="article.codeArticle + article.codeDeclinaison"
          class="selected-articles__list__item"
        >
          <span class="selected-articles__article__text">{{ article.codeArticle }} - {{ article.designation1 }}</span>
          <FontAwesomeIcon
            icon="times"
            size="1x"
            class="selected-articles__delete"
            @click="selectFilteredArticle(article)"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { REBOUND_DURATION, MINIMUM_CHARS_SEARCH } from '../../../config'
import { mapGetters, mapActions } from 'vuex'
import PlanVenteTree from '../../planVente/PlanVenteTree'
import Pagination from '../../Pagination'
export default {
  components: { PlanVenteTree, Pagination },
  data() {
    return {
      searchTimeout: null,
      filter: ''
    }
  },
  computed: {
    ...mapGetters([
      'filteredArticles',
      'selectedFilteredArticles',
      'searchingFilteredArticles',
      'filteredArticlesPage',
      'filteredArticlesPages'
    ]),
    filterLength() {
      return this.filter.length
    },
    hasFilteredArticles() {
      return this.filteredArticles.length !== 0
    },
    notEnoughCharactersTipCondition() {
      const { filterLength } = this
      return (
        filterLength < MINIMUM_CHARS_SEARCH
        && filterLength > 0
      )
    },
    showTip() {
      const { hasFilteredArticles } = this
      return (
        (
          !hasFilteredArticles
        && this.filterLength >= MINIMUM_CHARS_SEARCH
        && !this.searchingFilteredArticles
        )
        || (
          this.notEnoughCharactersTipCondition
        && !hasFilteredArticles
        )
      )
    },
    tip() {
      if (this.notEnoughCharactersTipCondition) {
        const remainingChars = MINIMUM_CHARS_SEARCH - this.filterLength
        let tip = `Encore ${remainingChars} caractère`
        return remainingChars === 1 ? tip : tip + 's'
      }
      return 'Aucun article trouvé'
    }
  },
  methods: {
    ...mapActions([
      'resetFilteredArticles',
      'getFilteredArticles',
      'setFilteredArticlesSearchString',
      'setLoadingFilteredArticles',
      'selectFilteredArticle',
      'setPageFilteredArticles',
      'clickPlanVenteRegroupement'
    ]),
    isSelected(codeArticle, codeDeclinaison) {
      const { selectedFilteredArticles } = this
      if (codeDeclinaison.length === 0) return selectedFilteredArticles[codeArticle] !== undefined
      return selectedFilteredArticles[`${codeArticle}.${codeDeclinaison}`] !== undefined
    },
    search({ data }) {
      const { filter } = this
      let { searchTimeout } = this
      const isNotDeleting = data !== null
      this.setFilteredArticlesSearchString(filter.toLowerCase())
      if (searchTimeout !== null) clearTimeout(searchTimeout)
      if (
        (
          this.filterLength >= MINIMUM_CHARS_SEARCH
          && isNotDeleting
        )
      ) this.setLoadingFilteredArticles(true)
      searchTimeout = setTimeout(
        () => {
          this.getFilteredArticles()
        }, REBOUND_DURATION
      )
    }
  }
}
</script>

<style scoped>
.main {
  display: flex;
  flex: 1;
  padding: 0 -1rem;
}

.main > * {
  margin: 0 1rem;
}

.search {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
}

.search__title {
  align-self: center;
  font-weight: bold;
}

.search__input__wrapper {
  display: inline-flex;
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 2rem;
}

.search__input__icon {
  height: 1.1rem;
  padding: 0.1em;
  color: white;
  background-color: gray;
}

.search__input {
  width: 100%;
  padding: 0.15rem 0.3rem;
}

.articles {
  display: flex;
  flex: 1.3;
  flex-direction: column;
  height: 24rem;
}

.articles__title {
  align-self: center;
  margin-bottom: 1em;
  font-weight: bold;
}

.articles__list {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 5rem;
  margin-left: 1rem;
}

.articles__list__tip {
  align-self: center;
  color: #a0a0a0;
}

.article {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: default;
  user-select: none;
  color: #434343;
}

.article--selected {
  font-weight: bold;
  color: #000;
}

.loader {
  align-self: center;
  margin: 0.5rem 0;
}

.loader-hidden {
  visibility: hidden;
}

.loader--active {
  color: #757575;
}

.selected-articles {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.selected-articles__title {
  align-self: center;
  margin-bottom: 1em;
  font-weight: bold;
}

.selected-articles__list {
  display: flex;
  flex-direction: column;
  cursor: default;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.selected-articles__list__item {
  display: flex;
  align-items: center;
  min-height: 25px;
  justify-content: center;
  width: 90%;
}

.selected-articles__article__text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.selected-articles__delete {
  margin-left: 0.5em;
  cursor: pointer;
  color: #333333;
}
</style>
